<template>
    <v-snackbar v-model="show" :timeout="timeout" :color="alertColor" top right elevation="24" :multi-line="multiLine">
        <div class="d-flex align-center">
            <v-icon class="mr-3" dark>
                {{ alertIcon }}
            </v-icon>

            <span
                class="flex-grow-1 alerta-sistema-msg"
                :class="{ 'alerta-sistema-msg--clickable': hasAction }"
                @click="onMessageClick"
            >
                {{ currentMessage }}
            </span>

            <v-btn
                v-if="hasAction"
                text
                dark
                small
                class="ml-2"
                @click.stop="runAction"
            >
                {{ actionText }}
            </v-btn>

            <v-btn icon dark small @click="closeAlert">
                <v-icon small>mdi-close</v-icon>
            </v-btn>
        </div>
    </v-snackbar>
</template>

<script>
export default {
    name: "AlertaSistema",

    data: () => ({
        show: false,
        currentMessage: "",
        currentType: "info",
        timeout: 5000,
        multiLine: false,
        actionText: "",
        actionHandler: null,
        clickMessageTriggersAction: false,
    }),

    computed: {
        alertColor() {
            const colors = {
                success: "green darken-1",
                error: "red darken-2",
                warning: "orange darken-2",
                info: "blue darken-1",
            };
            return colors[this.currentType] || colors.info;
        },

        alertIcon() {
            const icons = {
                success: "mdi-check-circle",
                error: "mdi-alert-circle",
                warning: "mdi-alert",
                info: "mdi-information",
            };
            return icons[this.currentType] || icons.info;
        },

        hasAction() {
            return typeof this.actionHandler === "function";
        },
    },

    methods: {
        /**
         * @param {String} message
         * @param {String} type - success/error/warning/info
         * @param {Number} duration - ms (0 = stay open until dismiss)
         * @param {Object} [options]
         * @param {String} [options.acaoTexto]
         * @param {Function} [options.onClick]
         * @param {Boolean} [options.clickMessage] - message click also runs action
         */
        showAlert(message, type = "info", duration = 5000, options = {}) {
            this.currentMessage = message || "";

            const validTypes = ["success", "error", "warning", "info"];
            this.currentType = validTypes.includes(type) ? type : "info";

            this.timeout = duration == null ? 5000 : duration;

            this.multiLine =
                this.currentMessage.length > 60 ||
                String(this.currentMessage).includes("\n");

            this.actionText = (options && options.acaoTexto) || "";
            this.actionHandler =
                options && typeof options.onClick === "function"
                    ? options.onClick
                    : null;
            this.clickMessageTriggersAction = !!(
                options &&
                options.clickMessage &&
                this.actionHandler
            );

            this.show = true;
        },

        onMessageClick() {
            if (this.clickMessageTriggersAction) {
                this.runAction();
            }
        },

        runAction() {
            if (typeof this.actionHandler === "function") {
                const handler = this.actionHandler;
                this.closeAlert();
                handler();
            }
        },

        closeAlert() {
            this.show = false;

            setTimeout(() => {
                this.currentMessage = "";
                this.currentType = "info";
                this.multiLine = false;
                this.actionText = "";
                this.actionHandler = null;
                this.clickMessageTriggersAction = false;
            }, 300);
        },
    },
};
</script>

<style scoped>
.v-icon {
    animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.8);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.v-snack__content {
    font-size: 14px !important;
    font-weight: 500;
}

.alerta-sistema-msg {
    white-space: pre-line;
}

.alerta-sistema-msg--clickable {
    cursor: pointer;
    text-decoration: underline;
}
</style>
